import React from 'react';

const PageNotFound = () => {
    return(
        <h1>Access is Denied</h1>
    )
}
export default PageNotFound;